/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * The one forced token refresh: mints a new ID token and copies its claims
 * into Redux.
 */

import { userActions } from "./user-slice";
import { claimsFromIdToken } from "./claimsFromIdToken";

/**
 * Rejects rather than swallowing. A revoked refresh token fails here with
 * `auth/user-token-expired`, and the caller needs that: it is the signal that
 * the person has been signed out of a gym, not a transient read error.
 *
 * @param {Object} user The signed-in Firebase user.
 * @param {Function} dispatch Redux dispatch.
 * @return {Promise<Object>} The ID token result.
 */
export const refreshClaims = async (user, dispatch) => {
  if (!user) {
    throw new Error("refreshClaims: no signed-in user");
  }
  const idTokenResult = await user.getIdTokenResult(true);
  dispatch(userActions.setClaims(claimsFromIdToken(idTokenResult.claims)));
  return idTokenResult;
};
